import axios from 'axios';

export default function getGraphQR({ payload }) {
    return new Promise((resolve, reject) => axios
        .get(`/analytic/admin/api/v1/managementportal/company/${payload.companyUuid}/branches/graph-qr`, {
            params: {
                branches: payload.branches.join(','),
                start: payload.start,
                end: payload.end,
            },
        })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message))
    );
}
